(() => {
  const paper = window.DirtPaper ||= {};
  if (paper.openDialog) return;
  let current;
  paper.openDialog = (name, trigger = document.activeElement) => {
    const template = [...document.querySelectorAll('[data-dialog-template]')].find(node => node.dataset.dialogTemplate === name);
    if (!template) return false;
    if (current?.name === name) return true;
    current?.close();
    const fragment = template.content.cloneNode(true);
    const dialog = fragment.querySelector('dialog');
    if (!dialog) return false;
    const controller = new AbortController();
    const overflow = document.documentElement.style.overflowY;
    const padding = document.documentElement.style.paddingRight;
    const scrollbar = innerWidth - document.documentElement.clientWidth;
    let closed = false;
    const close = () => {
      if (closed) return;
      closed = true;
      controller.abort();
      dialog.close();
      dialog.remove();
      document.documentElement.style.overflowY = overflow;
      document.documentElement.style.paddingRight = padding;
      current = null;
      if (trigger?.isConnected && trigger.getClientRects().length) trigger.focus({preventScroll: true});
      document.dispatchEvent(new CustomEvent('dirt:dialog-close', {detail: {name}}));
    };
    current = {name, close, template};
    document.body.append(fragment);
    dialog.setAttribute('data-open', '');
    dialog.setAttribute('data-lenis-prevent', '');
    document.documentElement.style.overflowY = 'hidden';
    if (scrollbar) document.documentElement.style.paddingRight = `${scrollbar}px`;
    dialog.addEventListener('cancel', event => {event.preventDefault(); close();}, {signal: controller.signal});
    dialog.addEventListener('close', close, {signal: controller.signal});
    dialog.addEventListener('click', event => {
      if (event.target.closest('[data-dialog-close]')) close();
      else if (event.target === dialog) {
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
      }
    }, {signal: controller.signal});
    dialog.showModal();
    document.dispatchEvent(new CustomEvent('dirt:dialog-open', {detail: {name, dialog}}));
    return true;
  };
  paper.closeDialog = () => current?.close();
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-dirt-open]');
    if (trigger?.href && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
    if (trigger && paper.openDialog(trigger.dataset.dirtOpen, trigger)) event.preventDefault();
  });
  document.addEventListener('shopify:section:unload', event => {
    if (current && event.target.contains(current.template)) current.close();
  });
  window.addEventListener('pagehide', () => current?.close());
})();
